export function toFixed(num, precision) {
    // Use string manipulation to avoid floating point precision issues
    // This ensures proper rounding at boundaries like 1.005 -> 1.01
    // Handle negative numbers by preserving the sign
    const isNegative = num < 0;
    const absNum = Math.abs(num);
    const rounded = Number(Math.round(absNum + 'e' + precision) + 'e-' + precision);
    return (isNegative ? -rounded : rounded).toFixed(precision);
}

// default on finnish
let thousandSeparator = ' '
let decimalMark = ','

export function setCurrencySeparators(thousands, decimals) {
    thousandSeparator = thousands
    decimalMark = decimals
}

export function stringToNumber(value) {
    if (typeof value === "number") {
        return Number.isFinite(value) ? value : NaN
    }

    if (typeof value !== "string") {
        return NaN
    }

    let text = value.trim()
    if (text === "") {
        return NaN
    }

    if (/[\u00A0\u202F]/.test(text)) {
        text = text.replace(/[\u00A0\u202F]/g, " ")
    }

    if (/[\t\n]/.test(text)) {
        text = text.replace(/[\t\n]/g, "")
    }

    if (thousandSeparator) {
        text = text.split(thousandSeparator).join("")
    }

    text = text.replace(/ /g, "")

    if (decimalMark && decimalMark !== ".") {
        text = text.split(decimalMark).join(".")
    }

    if (!/^[+-]?\d+(\.\d+)?$/.test(text)) {
        return NaN
    }

    const parsedNumber = Number(text)
    return Number.isFinite(parsedNumber) ? parsedNumber : NaN
}

export function numberToString(value, decimals = 0) {
    let numericValue = NaN

    if (typeof value === "string") {
        numericValue = stringToNumber(value)
    } else if (typeof value === "number") {
        numericValue = value
    } else {
        return ""
    }

    if (!Number.isFinite(numericValue)) {
        return ""
    }

    const fixedText = toFixed(numericValue, decimals)

    const sign = fixedText.startsWith("-") ? "-" : ""
    const unsignedText = sign ? fixedText.slice(1) : fixedText

    const parts = unsignedText.split(".")
    const integerPartRaw = parts[0]
    const fractionalPart = parts[1] ?? ""

    const integerPartFormatted = integerPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator)

    if (decimals > 0) {
        return sign + integerPartFormatted + decimalMark + fractionalPart
    }

    return sign + integerPartFormatted
}

export function formatCurrency(price, toString = true, decimals = 2) {
    const numericValue = stringToNumber(price)

    if (!Number.isFinite(numericValue)) {
        return toString ? "" : NaN
    }

    if (toString) {
        return numberToString(numericValue, decimals)
    }

    return Number(toFixed(numericValue, decimals))
}